import { Effluentform, Productionform, Socialform, Form } from "../../api";
import { effluentCodes, effluentKPIsCodes, effluentFormulasIndicators, convertUnitsFinal } from "./effluentForms";
import { computeRealKpiValue } from "./kpiRealValue";

const effluentController = new Effluentform();
const productionController = new Productionform();
const socialController = new Socialform();
const formController = new Form();

const CODE_TO_FIELD = Object.fromEntries(
  Object.entries(effluentKPIsCodes).map(([field, code]) => [code, field])
);

const RAW_FIELDS = Object.keys(effluentCodes);

/**
 * Lee el valor REAL de un KPI de Efluentes (sitio + año). Ver kpiRealValue.js.
 * El dashboard de Efluentes no llega a pedir la dotación de empleados (tiene
 * esa llamada comentada) aunque 2 de sus KPIs la necesitan como divisor —
 * acá sí la pedimos, así que para esos 2 KPIs este valor puede ser más
 * preciso que el que hoy muestra ese dashboard.
 */
export async function getRealEffluentKpiValue({ accessToken, site, kpiCode, year }) {
  const fieldKey = CODE_TO_FIELD[kpiCode];
  if (!fieldKey) return { available: false, reason: "unknown_kpi" };

  return computeRealKpiValue({
    accessToken,
    site,
    year,
    fieldKey,
    rawFields: RAW_FIELDS,
    formulasFn: effluentFormulasIndicators,
    convertFn: convertUnitsFinal,
    getRecordsFn: (t, s, ys) => effluentController.getEffluentFormsByLastYears(t, s, ys),
    recordsWrapperKey: "effluentForms",
    getUnitsFn: (t, s, y, f) => effluentController.getLastUnitFieldsByYear(t, s, y, f),
    getBaselineFn: (t, s, y) => productionController.getTotalBaselineByYearAndSite(t, s, y, "standardized_production"),
    getWorkersFn: (t, s, ys) => socialController.getTotalWorkersByYears(t, s, ys),
    getConfigFn: (t, s, moduleName, active) => formController.getFormsBySite(t, s, moduleName, active),
    moduleName: "effluent",
  });
}
